import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=2ecb2aa4&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=ts&"
export * from "./newsList.vue?vue&type=script&lang=ts&"
import style0 from "./newsList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsList.vue?vue&type=style&index=1&id=2ecb2aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecb2aa4",
  null
  
)

export default component.exports